interface FeaturesFlagsConf {
	[key: string]: {
		isEnabled: boolean;
		name: string;
		authorized_company_ids: number[];
		authorized_usernames: string[];
	};
}

export const featuresFlagsConf: FeaturesFlagsConf = {
	hasCRM: {
		authorized_company_ids: [
			25,
			297,
		],
		authorized_usernames: [],
		isEnabled: true,
		name: 'hasCRM',
	},
};
